import React, { Component } from "react";
import { formatISO } from "date-fns";

import ConfigService from "../../../services/ConfigService";
import CoreService from "../../../services/CoreService";
import AuthService from "../../../services/AuthService";
import AuthResourceService from "../../../services/AuthResourceService";
import LocalDbService from "../../../services/LocalDbService";
import LocalImageDbService from "../../../services/LocalImageDbService";
import LocalDocumentDbService from "../../../services/LocalDocumentDbService";
import LocalStorageService from "../../../services/LocalStorageService";
import BlobStorageService from "../../../services/BlobStorageService";

import EnvironmentManager from "../../../pages/Observation/Components/Managers/EnvironmentManager";
import SubscriptionManager from "../../../managers/SubscriptionManager";
import FileManager from "../../../managers/FileManager";
import DataApiManager from "../../../managers/DataApiManager";

import JavascriptHelpers from "../../../components/lib/Javascript/JavascriptHelpers";
import JwtToken from "../../../components/lib/tokens/JwtToken";

import HealthInfo from "../../../models/HealthInfo";
import HealthInfoDetail from "../../../models/HealthInfoDetail";
import { HealthStatusType } from "../../../models/HealthStatusType";

import ErrorEvent from "../../../models/ErrorEvent";
import ServiceResponse from "../../../models/ServiceResponse";




function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default class LotWatcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRunning: false,
      watchListLastUpdated: JavascriptHelpers.isoUtcNow(),
    };

    this.configService = new ConfigService();
    this.coreService = new CoreService();
    this.authService = new AuthService();
    this.authResourceService = new AuthResourceService();
    this.localImageDbService = new LocalImageDbService();
    this.localDocumentDbService = new LocalDocumentDbService();
    this.blobStorageService = new BlobStorageService();
    this.localObsDbService = new LocalDbService("observation", "obsDb", [{field: "offlineId", name: "offlineId", unique: true}]);
    this.localStorageService = new LocalStorageService();
    this.watchInterval = new ConfigService().getWatchInterval(); // milliseconds

    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.refreshWatchListQueue = this.refreshWatchListQueue.bind(this);
    this.processExpirationCheck = this.processExpirationCheck.bind(this);
    this.processLocalQueue = this.processLocalQueue.bind(this);
    this.processHealthCheck = this.processHealthCheck.bind(this);
    this.interval = null;

    this.dataApiManager = new DataApiManager();
  }

  componentWillUnmount() 
  {
    this.stop();
  }

  componentDidUpdate(prevProps, prevState) 
  {
    if (this.props.runLotWatcher !== prevProps.runLotWatcher) {
      console.log(
        "Watcher was commanded to " + this.props.runLotWatcher
          ? "start"
          : "stop"
      );
      this.stop();
      if (this.props.runLotWatcher) {
        this.start();
      }
    }
  }

  async start() 
  {
    if (this.state.isRunning) return;
    console.log("Starting Watcher...");
    this.interval = setInterval(() => {
      this.refreshWatchListQueue();
    }, this.watchInterval);
  }

  stop() 
  {
    console.log("Stopping Watcher");
    this.setState({ isRunning: false });
    clearInterval(this.interval);
  }


  // this is actually our MAIN loop, so health checks, etc may be done here. 
  async refreshWatchListQueue() 
  {
    try {
      this.props.onLotWatcherRunningStatusChange(true);
      this.setState({ isRunning: true });
      this.stop();

      if (!this.processExpirationCheck()) return;
      await this.processLocalQueue();
      await this.processHealthCheck();

      if (this.props.autoRefresh) this.props.onTriggerAutoRefresh();
      
      this.setState({ watchListLastUpdated: JavascriptHelpers.isoUtcNow() });
    } 
    catch(e) {
      this.props.onToastRequest("error", "There was a unexpected problem with the main loop");
      // TBD - Okay. What do we do with this?
    } 
    finally {
      this.setState({ isRunning: false });
      this.props.onLotWatcherRunningStatusChange(false);
      this.start();
    }
  }


  processExpirationCheck()
  {
    if (!this.props.userSession) return false;
    this.props.updateSessionExpiration(JwtToken.toExpiredDateTime(this.props.userSession.token));
    if (JwtToken.isTokenExpired(this.props.userSession.token)) 
    {
      console.group("Token Expiration Check");
      console.log("The user token has expired.");
      console.info(this.props.userSession.token);
      console.groupEnd();
      this.stop();
      this.props.onExpiredToken(this.props.userSession.token);
      return false;
    }
    return true;
  }

  async processLocalQueue()
  {

       var localQueueResponse = new ServiceResponse(false, []);
       var isEmptyQueue = true;

      try
      {


        /* Do we have any observations stored locally? */
        var waitingQueueResponse = await this.localObsDbService.fetchAllObservations();
        console.group("Local Storage Queue Check");
        console.info(waitingQueueResponse);
        console.groupEnd();
        if (waitingQueueResponse.hasError)
        {
          this.props.onToast("error", waitingQueueResponse.toMessageString());
          return;
        }
        var queue = waitingQueueResponse.data;
        this.props.onUpdateInQueueCount(queue.length);
        console.log("Waiting Queue: ");
        console.info(queue);
        console.log("Queue Length: " + queue.length);
        if (queue.length < 1) return;
        if (queue.length > 0)
        {
          isEmptyQueue = false;
          var queueCount = queue.length;
          for (var i = 0; i < queue.length; i++) 
          {
            let observation = queue[i];
            console.log("Observation to Post:");
            console.info(observation);
            console.info("Posting to core:");
            // check if this has a delayed environment check. We assume we are ONLINE if we are uploading
            if (observation.data.Raw.updateOnUpload)
            {
              localQueueResponse.messages.push("updating environment information.");
              var isoObservationDateTime = observation.data.Raw["historical_datetime"];
              var lat = observation.data.Raw.latitude;
              var lng = observation.data.Raw.longitude;
              if ((isoObservationDateTime) && (lat) && (lng))
              {
                try
                {
                  // we need to go back and get as much environment info as we can
                  var environmentManager = new EnvironmentManager(this.configService.getGeolocationOptions(), this.props.onlineInfo);
                  var addressUpdatedObservation = await environmentManager.updateObservationWithAddress(observation, lat, lng, this.props.userSession.gcid, this.props.userSession.token);
                  observation = await environmentManager.updateObservationWithHistoricalWeatherData(addressUpdatedObservation, lat, lng, isoObservationDateTime, this.props.userSession.gcid, this.props.userSession.token);
                  localQueueResponse.messages.push("Successfully updated observation with historical address and weather.");
                } catch (environUpdateErr)
                {
                  console.info(environUpdateErr);
                  localQueueResponse.hasError = true;
                  localQueueResponse.messages.push("Unexpected error in updating observation with historical address and weather.");
                  localQueueResponse.messages.push(environUpdateErr.toString());
                }
              }
            }
            var postResult = await this.coreService.postObservation(observation, this.props.userSession.gcid, this.props.userSession.token);
            console.info(postResult);
            if (postResult.hasError)
            {
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("Error posting observation to Core API.");
              localQueueResponse.messages.push(...postResult.messages);
              
              this.props.onToastRequest("error", "There was a problem posting local observation to core. " + "[" + postResult.messages[0] + "]");
              // what do we do? Should we be counting the attempts and STOP trying to post if we hit a maximum number of attempts? 
              return;
            }
            localQueueResponse.messages.push("Observation " + observation.identifiers.id + " has posted successfully to the Core.");

            // if we have any lookup entity ids, check if we should be removing them
            try
            {
              if (observation.data.Raw.lookupEntityIdList) 
              {
                const keys = Object.keys(observation.data.Raw.lookupEntityIdList);
                for(const ky of keys)
                {
                  var entityId = observation.data.Raw.lookupEntityIdList[ky];
                  var deleteLookupEntityResponse = await this.coreService.deleteLookupEntity(entityId, this.props.userSession.gcid, this.props.userSession.token);
                  console.info(deleteLookupEntityResponse);
                  var deleteLocalLookupEntity = this.localStorageService.deleteLookupEntity(ky, entityId, this.props.userSession.gcid);
                  console.info(deleteLocalLookupEntity);
                }
                localQueueResponse.messages.push("Lookup Entities deleted successfully.");
              }
            } catch(lookupEntityErr)
            {
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("There was a problem deleting lookup entities.");
              localQueueResponse.messages.push(lookupEntityErr.toString());
            }

            try
            {
              var fileManager = new FileManager();
              // upload all associated images and documents
              var imgPostResult = await fileManager.uploadUserImages(observation, this.props.userSession);
              console.info(imgPostResult);
              if (imgPostResult.hasError)
              {
                localQueueResponse.hasError = true;
                localQueueResponse.messages.push("Problem posting Image(s).");
                localQueueResponse.messages.push(...imgPostResult.messages);
                //this.props.onToastRequest("error", "There was a problem posting local observation Images to core. " + "[" + imgPostResult.messages[0] + "]");
              }

              var docPostResult = await fileManager.uploadUserDocuments(observation, this.props.userSession);
              console.info(docPostResult);
              if (docPostResult.hasError)
              {
                localQueueResponse.hasError = true;
                localQueueResponse.messages.push("roblem posting Document(s).");
                localQueueResponse.messages.push(...docPostResult.messages);
                //this.props.onToastRequest("error", "There was a problem posting local observation documents to core. " + "[" + docPostResult.messages[0] + "]");
              }
            } catch (fileManagerErr)
            {
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("There was a unexpected problem posting user images and/or documents.");
              localQueueResponse.messages.push(fileManagerErr.toString());
            }

            try
            {
              var schema = this.localStorageService.getSchema(observation.data.schema.id);
              localQueueResponse.messages.push("Schema " + observation.data.schema.id + " pulled successfully from local storage.");
            }
            catch(fetchSchemaErr)
            {
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("There was a problem fetching the schema " + observation.data.schema.id);
            }

            try
            {
            // deal with potential inboundQueue details we need to delete
              if (schema.inboundQueue?.Enabled)
              {
                if (schema.inboundQueue.DetailKeysInfo?.UseDetailKeys)
                {
                  var detailKeysProp = schema.inboundQueue.DetailKeysInfo.DetailKeysPropId;
                  var detailKeysVal = observation.data.Raw[detailKeysProp];
                  var keysToDelete =  (Array.isArray(detailKeysVal)) ? detailKeysVal : new [detailKeysVal];
                  {
                    var deleteInboundKeysResult = await this.coreService.postInboundQueueDetailKeysDeleteRequest(keysToDelete, schema.schemaInfo.id, this.props.userSession.gcid, this.props.userSession.token );
                    console.info(deleteInboundKeysResult);
                    if (deleteInboundKeysResult.hasError)
                    {
                      localQueueResponse.hasError = true;
                      localQueueResponse.messages.push("There was a problem deleting inbound queue items.");
                      localQueueResponse.messages.push(...deleteInboundKeysResult.messages);
                    }
                    else {
                      localQueueResponse.messages.push("Inbound Keys for observation deleted successfully.");
                    }
                  }
                }
              }
            } catch(localQueueErr)
            {
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("Unexpected problem removing inbound queue records.");
              localQueueResponse.messages.push(localQueueErr.toString());
              console.log("Error deleting inbound queue keys.");
              console.info(localQueueErr);
            }
          

            try
            {
              localQueueResponse.messages.push("Checking for subscriptions notifications...");
              var subscriptionManager = new SubscriptionManager();
              var subscriberSendResult = await subscriptionManager.sendSubscriptions(observation, schema, this.props.userSession.uid, this.props.userSession.gcid, this.props.userSession.token);
            
              console.log("Subscribers (if any) sent notifications");
              console.info(subscriberSendResult);

              if (subscriberSendResult.hasError)
              {
                localQueueResponse.hasError = true;
                localQueueResponse.messages.push("Error sending subscriber notifications.");
                localQueueResponse.messages.push(...subscriberSendResult.messages);
              }
              else 
              {
                localQueueResponse.messages.push("Successfully sent subscription notifications.");
                localQueueResponse.messages.push(...subscriberSendResult.messages);
              }
            } catch(subscriptionsErr)
            {
              console.log("Error sending to subscribers");
              console.info(subscriptionsErr);
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("There was an unexpected error sending notifications to subscribers.");
              localQueueResponse.messages.push(subscriptionsErr.toString());
            }


            // post to Data API. Note that we only upload fact information 
            try
            {
              if (schema.dataApi?.active)
              {
                var uploadData = [];
                uploadData.push(observation);
                var response = await this.dataApiManager.onUploadAsJsonRequest(schema, uploadData, this.props.userSession);
                if (response.hasError)
                {
                  console.log("Error posting observation to DataAPI.");
                  console.info(response);
                  localQueueResponse.hasError = true;
                  localQueueResponse.messages.push("There was an error uploading Data API data to the core.");
                  localQueueResponse.messages.push(...response.messages);
                }
                else
                {
                  console.log("Successfully posted Observation Fact data to Core API");
                }
              }
            }
            catch(dataApiErr)
            {
              // TBD - what are we going to do with an error here? 
              console.log("Unexpected error posting observation Fact data to Core API");
              console.info(dataApiErr);
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("Unexpected error in posting Data API data to core.");
              localQueueResponse.messages.push(dataApiErr.toString());
              //this.props.onToastRequest("error", "There was a problem uploading data. Please report the following error to your Application Administrator -[" + e.message + "]");
            }

            // do NOT let data api or subscription posting cause the record to not get posted!
            // remove the queued record
            try
            {
              var deleteObsResponse = await this.localObsDbService.deleteObservation(observation.identifiers.id);
              if (deleteObsResponse.hasError)
              {
                console.info(deleteObsResponse);
                localQueueResponse.hasError = true;
                localQueueResponse.messages.push("Problem deleting posted observation.");
                localQueueResponse.messages.push(...deleteObsResponse.messages);
              }
              {
                localQueueResponse.messages.push("Observation removed from local storage successfully.");
              }
              var deleteUserImgsResponse = await fileManager.deleteUserImages(observation);
              if (deleteUserImgsResponse.hasError)
              {
                console.info(deleteUserImgsResponse);
                localQueueResponse.hasError = true;
                localQueueResponse.messages.push("Problem deleting posted user images.");
                localQueueResponse.messages.push(...deleteUserImgsResponse.messages);
              }
              else {
                localQueueResponse.messages.push("Any observation images removed from local storage successfully.")
              }
              var deleteUserDocumentsResponse = await fileManager.deleteUserDocuments(observation);
              if (deleteUserDocumentsResponse.hasError)
              {
                console.info(deleteUserDocumentsResponse);
                localQueueResponse.hasError = true;
                localQueueResponse.messages.push("Problem deleting posted user documents.");
                localQueueResponse.messages.push(...deleteUserDocumentsResponse.messages);
              }
              else {
                localQueueResponse.messages.push("Any observation documents removed from local storage successfully.");
              }
            }
            catch(deleteErr)
            {
              console.info(deleteErr);
              localQueueResponse.hasError = true;
              localQueueResponse.messages.push("Unexpected problem deleting observations images and documents.");
              localQueueResponse.messages.push(deleteErr.toString());
            }

            queueCount--;
            this.props.onUpdateInQueueCount(queueCount);
            localQueueResponse.messages.push("Local Queue count updated to " + queueCount.toString() + " and observation posting complete.");

          }
        }

      } catch(overallErr)
      {
        console.info(overallErr);
        localQueueResponse.hasError = true;
        localQueueResponse.messages.push("There was an unexpected error running the posting loop.");
        localQueueResponse.messages.push(overallErr.toString());
      }
      finally 
      {
        try
        {
          if (isEmptyQueue) return; // do not log if nothing was waiting!
          var orgConfig = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
          if (!orgConfig.logging?.enabled) return;
          if ((orgConfig.logging.errorsOnly) && (!localQueueResponse.hasError)) return;
          var logEvent = new ErrorEvent(this.props.userSession.gcid, formatISO(new Date()), "obs.lotwatcher", this.props.userSession.uid, this.props.userSession.uid);
          logEvent.errorCode = (localQueueResponse.hasError) ? "1": "0";
          logEvent.errorDescription = "Main update loop";
          logEvent.comments = "from lotWatcher";
          logEvent.stackTrace = JSON.stringify(localQueueResponse);

          var saveLogResponse = await this.coreService.postErrorEvent(logEvent, this.props.userSession.gcid, this.props.userSession.token);
          if (saveLogResponse.hasError)
          {
            this.props.onToastRequest("error", "There was a problem saving loop posting log data. Please report the following error to your Application Administrator -[" + logEvent.stackTrace() + "]");

          }
        }
        catch (finallyErr)
        {
          this.props.onToastRequest("error", "There was a problem saving loop posting log data. Please report the following error to your Application Administrator -[" + finallyErr.toString() + "]");

        }
      }

  }




  toHealthInfoDetail(serviceName, updateDateTime, dbResponse)
  {
    var result = new HealthInfoDetail(serviceName, updateDateTime, 
      (dbResponse.hasError) ? HealthStatusType.ERROR : HealthStatusType.OK,
      (dbResponse.hasError) ? dbResponse.messages : "Ok"
    );
  }



  async processHealthCheck()
  {

    var hasPrevInfo = (this.props.healthInfo);

    var corePingResponse = await this.coreService.pingCore();
    var coreDbPingResponse = await this.coreService.pingCore();
    var authPingResponse = await this.authService.ping(this.props.userSession.token);
    var authResourcePingResponse = await this.authResourceService.pingCore(this.props.userSession.token);

    // if the current update has an error, then the last problem update BECOMES the current Update
    // If there is NO lastProblemUpdate AND the currentUpdate is NOT an error, then leave it null.
    // If there is a lastProblemUpdate AND the currentUpdate is NOT an error, then set to lastProblemUpdate.

    var newHealthInfo = new HealthInfo(this.props.userSession.gcid, this.props.userSession.uid, this.props.userSession.currentLocationId, JavascriptHelpers.isoNow());
    
    newHealthInfo.coreHealth.currentUpdate = new HealthInfoDetail("core-api", formatISO(new Date()), (corePingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (corePingResponse.messages) ? corePingResponse.messages : []);
      newHealthInfo.coreHealth.lastProblemUpdate = (corePingResponse.hasError) ? 
      newHealthInfo.coreHealth.currentUpdate 
      : (this.props.healthInfo?.coreHealth?.lastProblemUpdate) ? this.props.healthInfo.coreHealth.lastProblemUpdate : null;

    newHealthInfo.coreDbHealth.currentUpdate = new HealthInfoDetail("core-db", formatISO(new Date()), (coreDbPingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (coreDbPingResponse.messages) ? coreDbPingResponse.messages : []);
        newHealthInfo.coreDbHealth.lastProblemUpdate = (coreDbPingResponse.hasError) ? 
        newHealthInfo.coreDbHealth.currentUpdate 
        : (this.props.healthInfo?.coreDbHealth?.lastProblemUpdate) ? this.props.healthInfo.coreDbHealth.lastProblemUpdate : null;

    newHealthInfo.authHealth.currentUpdate = new HealthInfoDetail("auth-api", formatISO(new Date()), (authPingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (authPingResponse.messages) ? authPingResponse.messages : []);
        newHealthInfo.authHealth.lastProblemUpdate = (authPingResponse.hasError) ? 
          newHealthInfo.authHealth.currentUpdate 
          : (this.props.healthInfo?.authHealth?.lastProblemUpdate) ? this.props.healthInfo.authHealth.lastProblemUpdate : null;

  
    newHealthInfo.authResourceHealth.currentUpdate = new HealthInfoDetail("auth-api", formatISO(new Date()), (authResourcePingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (authResourcePingResponse.messages) ? authResourcePingResponse.messages : []);
          newHealthInfo.authResourceHealth.lastProblemUpdate = (authResourcePingResponse.hasError) ? 
            newHealthInfo.authResourceHealth.currentUpdate 
            : (this.props.healthInfo?.authResourceHealth?.lastProblemUpdate) ? this.props.healthInfo.authResourceHealth.lastProblemUpdate : null;

     this.props.onHealthInfoUpdate(newHealthInfo); 

  }





  render() 
  {
    return (<span />);
  }
}
